import React from 'react';
import { RootLayout } from 'common/components';
import { useRegionIdSelector } from 'modules/model-json';
import { MODIFIED_KITCHEN_BREADCRUMBS, KITCHEN_PATH } from './kitchen-constants';
import { NewKitchen } from './new-kitchen';

/**
 * Вью страницы "Кухни"
 */
export const Kitchen = () => {
  const regionId = useRegionIdSelector();

  return (
    <RootLayout customBreadcrumbs={MODIFIED_KITCHEN_BREADCRUMBS} currentPage={KITCHEN_PATH}>
      <NewKitchen regionId={regionId} />
    </RootLayout>
  );
};
